export const NOT_STARTED = ["Not Started"];
export const IN_PROGRESS = ["In Progress", "Inprogress", "Pending", "In-Progress", "InProgress"];
export const COMPLETE = ["Completed", "Complete"];